// 최초 초기설정: 관리자 비밀번호 + 홈 이름 설정 (브라우저 입력 → 항상 UTF-8)
import { useState } from 'preact/hooks';
import { api, ApiError } from '../core/ApiClient';
import { PasswordInput } from './PasswordInput';

interface Props {
  defaultTitle: string;
  onDone: () => void;
}

export function InitSetup({ defaultTitle, onDone }: Props) {
  const [siteTitle, setSiteTitle] = useState(defaultTitle);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: Event) => {
    e.preventDefault();
    setErr('');
    if (password.length < 4) return setErr('비밀번호는 4자 이상이어야 합니다.');
    if (password !== confirm) return setErr('비밀번호가 일치하지 않습니다.');
    if (!siteTitle.trim()) return setErr('홈 이름을 입력하세요.');

    setBusy(true);
    try {
      await api.initSetup({ password, siteTitle: siteTitle.trim() });
      onDone();
    } catch (ex) {
      setErr(ex instanceof ApiError ? ex.message : '초기설정에 실패했습니다.');
      setBusy(false);
    }
  };

  return (
    <div class="gate">
      <form class="gate__card" onSubmit={submit}>
        <img class="gate__logo" src="/logo.webp" alt="로고" />
        <h1 style="font-size:18px;margin:0 0 4px">초기 설정</h1>
        <p style="color:var(--c-text-muted);font-size:13px;margin:0 0 16px">
          최초 1회 관리자 비밀번호와 홈 이름을 설정합니다.
        </p>
        <div class="field" style="text-align:left">
          <label>홈 이름</label>
          <input
            class="input"
            value={siteTitle}
            onInput={(e) => setSiteTitle((e.target as HTMLInputElement).value)}
          />
        </div>
        <div class="field" style="text-align:left">
          <label>비밀번호 (4자 이상)</label>
          <PasswordInput value={password} onValue={setPassword} />
        </div>
        <div class="field" style="text-align:left">
          <label>비밀번호 확인</label>
          <PasswordInput value={confirm} onValue={setConfirm} />
        </div>
        <button class="btn btn--primary" type="submit" style="width:100%" disabled={busy}>
          {busy ? '설정 중…' : '설정 완료'}
        </button>
        {err && <div class="msg-error">{err}</div>}
      </form>
    </div>
  );
}
